import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import route_img from '@/public/article/Route Optimization.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/electrician/Electrician-bg.webp';
import image4 from '@/public/industries/hvac/Reporting-and-analytics.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title:
      'How does Orcatec construction management software help my business?',
    text: `Orcatec's contractor service management elevates business operations by providing
    comprehensive job tracking and resource management tools. This software facilitates better
    planning, improves real-time communication, and enhances project delivery, making it
    indispensable for efficient construction management.`,
  },
  {
    title:
      'Does your construction management software integrate with QuickBooks?',
    text: `Orcatec offers robust integration with QuickBooks, aligning your project management with your
    financial workflows. This connectivity ensures that financial tracking accurately reflects ongoing
    project expenses, enhancing financial oversight.`,
  },
  {
    title: 'Who needs construction software?',
    text: `Construction software is a critical tool for contractors, project managers, builders, and anyone
    involved in the construction industry who seeks to optimize project delivery and enhance
    business operations. It's particularly beneficial for consolidating various management tasks into
    one unified system.`,
  },
];

const testimonals = [
  {
    text: `Implementing Orcatec has transformed the management of our construction sites. Its powerful
    scheduling and real-time client management features have substantially boosted our efficiency
    in project delivery.`,
    name: 'Carlos G.,',
    position: 'Vista Building Group',
  },
  {
    text: `Orcatec's communication tools and document-sharing capabilities have markedly reduced site
    delays. It's an essential tool for construction businesses aiming to enhance team productivity
    and coordination.`,
    name: 'Emily R.,',
    position: 'Summit Constructors',
  },
  {
    text: `Tracking project milestones and managing transactions through Orcatec is incredibly
    straightforward. It effortlessly scales with our business; we couldn't handle our construction
    workload nearly as well without it.`,
    name: 'David P.,',
    position: 'Apex Building Solutions',
  },
];

const industries = {
  title: 'Our industries',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Construction Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Optimized Dispatch and Scheduling',
      },
      href: '#',
      tag: 'Job Scheduling',
      title: 'Optimized Dispatch and Scheduling',
      text: `Our smart dispatch system and scheduling software for construction companies
      revolutionize task assignment and management. Designed specifically for construction
      businesses, this feature ensures efficient resource coordination, improving project timelines and
      operational efficiency.`,
      list: [
        { text: 'Efficient job planning and scheduling.' },
        { text: 'Minimization of scheduling overlaps.' },
        { text: 'Optimal resource allocation for various job types.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Customer management',
      title: 'Advanced Customer Management/CRM',
      text: `Strengthen client relationships with our advanced CRM tools. Manage client data, track
      interactions, and tailor services to increase client satisfaction and foster repeat business and
      referrals in the competitive construction industry.`,
      list: [
        { text: 'Detailed tracking of customer interactions and inquiries.' },
        { text: 'Management of customer preferences and individual needs.' },
        { text: 'Comprehensive service history recording for each client.' },
      ],
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and Billing ',
      },
      href: '#',
      tag: 'Invoicing and payments',
      title: 'Seamless Invoicing and Payments',
      text: `Simplify the billing process with our construction management and billing software.
      Automate and expedite invoice creation and payments to enhance cash flow management,
      allowing your team to focus on project delivery.`,

      list: [
        { text: 'Automated invoicing and billing process.' },
        { text: 'Reduction of billing errors and discrepancies.' },
        { text: 'Easy tracking and management of financial transactions.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4.src,
        alt: 'Reporting and analytics',
      },
      href: '#',
      tag: 'Reporting and analytics',
      title: 'Data-Driven Reporting and Analytics',
      text: `Unlock actionable insights with our enhanced reporting and analytics. This powerful feature
      helps you understand project performance, financial health, and customer trends, guiding
      strategic decisions for continuous improvement.`,
      list: [
        { text: 'Insightful business analytics and customizable reports.' },
        { text: 'Monitoring of performance metrics and customer engagement.' },
        { text: 'Data analysis tools for strategic decision-making.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: route_img,
        alt: 'AI Route Optimization',
      },
      href: '#',
      tag: 'Route Optimization',
      title: 'AI Route Optimization',
      text: `AI-route optimization in the construction sector leverages data on traffic patterns, technician
      placements, and work site locations to map out the most efficient travel routes. This approach
      significantly cuts down on time spent on the road and reduces fuel expenditure.`,
      list: [
        { text: 'Provision of real-time updates on job status and changes.' },
        {
          text: 'Mobile access to job information and schedules.',
        },
        { text: 'Immediate communication and collaboration tools.' },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Construction Service Software',
  title: {
    first_part: 'Elevate Your Projects with',
    second_part: 'Construction Management Software',
  },
  description: `Advance your construction service management with our free, all-in-one software. Designed
    for contractors and subcontractors, our tool streamlines scheduling, project management, and
    billing. It effortlessly improves efficiency, reduces costs, and boosts profitability. It's not just
    software—it  your project's success partner.`,
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '35%', description: 'Workforce Productivity' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What Is Construction Software?',
  },
  title: 'What Is Construction Software?',
  description: `Construction software, like Orcatec is a specialized type of project management tool designed to assist contractors in the construction industry with the planning, execution, coordination, and monitoring of construction projects.`,
  second_description:
    'Contractor service software typically offers scheduling, budget management, communication, resource allocation, and documentation management features. It enables seamless collaboration between all stakeholders, including contractors, subcontractors, and clients. Also, Orcatec provides a reliable QuickBooks Online integration for complete business accounting. ',
  item: [
    {
      title: 'Increased Productivity',
      description:
        'Automate routine tasks such as scheduling, dispatching, and invoicing so you can focus on more important matters.',
    },
    {
      title: 'Improved Customer Service',
      description:
        'Ensure quick communication with customers, timely invoicing, and quality control of services.',
    },
    {
      title: 'Easy Control of All Processes',
      description:
        'Have quick access to all your business information in one place, from any device.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Orcatec Is Right For You?',
  },
  title: 'Why Orcatec Is Right For You?',
  description: `Orcatec's construction service management software is designed to cater specifically to the
  needs of contractors and construction businesses. It's not just about managing projects; it's
  about doing so in a way tailored to the unique challenges and demands of the construction
  industry. Find out the key reasons why Orcatec stands out as the optimal choice:`,
  item: [
    {
      title: `Start with zero investment and experience Orcatec's software's transformative
      capabilities`,
      description: `Our free service contractor software is designed to let you explore its
        functionalities and see firsthand how it can benefit your operations without any upfront
        costs.`,
    },
    {
      title: `With Orcatec, you're in control of your software expenses`,
      description: ` Choose only the
        functionalities you need, ensuring you pay for nothing more than what adds direct value
        to your business. This flexibility allows you to scale your use of the construction
        management software for subcontractors as your business grows, adapting to your
        changing needs without unnecessary expenditure.`,
    },
    {
      title: `Whether you're on-site, in the office, or on the move, Orcatec's business management
      software for service contractors is with you`,
      description: ` It's designed for seamless operation across
      PCs, tablets, and mobile phones, ensuring you have access to your project data
      whenever you need it, wherever you are.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of knowledge with our blog, exploring the latest trends, insights, and best
  practices in the construction industry. Stay ahead by enriching your expertise with our in-depth
  articles and discussions.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Unlock Your Project's Full Potential with Orcatec!
  Elevate your construction management today with Orcatec's innovative solutions. Make sure to
  optimize your projects with our cutting-edge software.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
